export const API_PATH_apiWorkzoneItemHistorySearch = '/services/devices-mgtm/apiWorkzoneItemHistorySearch';
